// extracted by mini-css-extract-plugin
export default {"NewBox":"box_NewBox__x-Wz0","row":"box_row__K1Mt7","description":"box_description__JuvE3","title":"box_title__S+D3J","icon":"box_icon__m9p7Q"};